import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { EncryptionService } from 'src/app/services/encryption.service';
import { ActivatedRoute } from '@angular/router';
import { OrganizerSessionService } from 'src/app/services/organizer-session.service';

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss']
})
export class EventComponent implements OnInit {


  aboutForm!: FormGroup;
  submitted = false;
  countries: any = [];
  states: any = [];
  cities: any = []
  datam: any;
  eventCategories = [

  ];

  eventsPerYearOptions = [

  ];

  audienceSizeOptions = [

  ];
  public formfillNext: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private _ds: DataService,
    private enc: EncryptionService,
    private router: Router,
    private organizerSession: OrganizerSessionService
  ) { }

  ngOnInit(): void {
    // ✅ 1. Pehle form banao
    this.aboutForm = this.fb.group({
      eventsPerYear: [null, Validators.required],
      audienceSize: [null, Validators.required],
      categories: [[], Validators.required]
    });

    // ✅ 2. Dropdown data load karo (items)
    this.getAllcountries();
    this.getAlleventCategeory();
    

    // ✅ 3. Ab route + API call karo
    this.route.queryParams.subscribe(params => {
      const id = this.organizerSession.validateRouteOrganizerId(
        params['id'],
        '/event-information',
        this.router
      );
      if (id == null) return;

      this._ds.getUniqueUserData(id).subscribe((res: any) => {
        const allData = this.enc.decrypt(res.data);
        console.log(allData)

        if (allData.events_category_exists == true) {
          this.formfillNext = true
          Object.keys(this.aboutForm.controls).forEach(key => {
            this.aboutForm.get(key)?.disable();
          });

        } else {
          this.formfillNext = false

        }

        const selectedNames = allData.organizer.categories; // ["Workshop", "Meetup"]
        console.log(selectedNames)

        setTimeout(() => {
          this.aboutForm.patchValue({
            categories: selectedNames,               // 👈 YAHI FIX HAI
            audienceSize: allData.organizer.audience_size_range,
            eventsPerYear: allData.organizer.events_per_year_range
          });

        }, 500);

      });
    });
    this.getallEventPerYears();
    this.getAudienceSize();

  }
  logout() {
    localStorage.clear();
    this.router.navigate(['/login'], { replaceUrl: true });
  }

  getAllcountries() {
    this._ds.allCountry().subscribe((res) => {
      // this.countries = res
      const decryptedData = this.enc.decrypt(res.data);
      this.countries = decryptedData.data;
    })
  }

  getAlleventCategeory() {
    this._ds.allEventCategeory().subscribe((res) => {
      const decryptedData = this.enc.decrypt(res.data);
      this.eventCategories = decryptedData.data;

      console.log(this.eventCategories)

    })
  }

  getAudienceSize() {
    this._ds.audienceSize().subscribe((res) => {
      const decryptedData = this.enc.decrypt(res.data);
      this.audienceSizeOptions = decryptedData.data;
      console.log('✅ Decrypted response:', decryptedData);
    })
  }


  onStateChange(stateId: any) {
    this.getAllcities(stateId.id);
  }

  getAllcities(id: any) {
    this._ds.allCities(id).subscribe((res) => {
      const decryptedData = this.enc.decrypt(res.data);
      this.cities = decryptedData.data;
    })
  }

  getallEventPerYears() {
    this._ds.eventPerYears().subscribe((res) => {
      // this.countries = res
      const decryptedData = this.enc.decrypt(res.data);
      this.eventsPerYearOptions = decryptedData.data;
      console.log(this.eventsPerYearOptions)
    })
  }

  navigateStep() {
    const organizer = JSON.parse(localStorage.getItem('organizer') || 'null');
    const user = JSON.parse(localStorage.getItem('user') || 'null');

    // 🔥 pehle user.organizer se try karo
    const orgType = user?.organizer?.organizer_type || organizer?.organizer_type;
    const orgId = user?.organizer?.id || organizer?.id;

      this.router.navigate(['/gst-registration'], { queryParams: { id: orgId } });

    // if (!orgType || !orgId) {
    //   console.error('❌ Organizer data missing in both user & organizer');
    //   return;
    // }

    // if (orgType === 'organization') {
    //   this.router.navigate(['/organize'], { queryParams: { id: orgId } });
    // } else {
    //   this.router.navigate(['/individual'], { queryParams: { id: orgId } });
    // }

    // this.route.queryParams.subscribe(params => {
    //   const id = params['id'];
    //   this.router.navigate(['/gst-registration'], { queryParams: { id: id } });

    // })
  }


  submitForm() {
    this.submitted = true;                 // 🔥 error dikhane ke liye
    this.aboutForm.markAllAsTouched();
    if (this.aboutForm.invalid) return;
    const form = this.aboutForm.value;

    const organizer = JSON.parse(localStorage.getItem('organizer') || 'null');
    const user = JSON.parse(localStorage.getItem('user') || 'null');

    const organizerId =
      organizer?.id
        ? organizer.id
        : user?.organizer?.id
          ? user.organizer.id
          : null;

    const payload = {
      audience_size_range: form.audienceSize,
      events_per_year_range: form.eventsPerYear,
      categories: form.categories,
      organizer_id: organizerId
    };

    console.log(payload)
    // this.router.navigate(['/platform-legal']);
    this._ds.updateOrganizer(payload).subscribe({
      next: (res) => {
        console.log('Organizer created (200)', res);

        if (res?.data) {
          const decryptedData = this.enc.decrypt(res.data);
          console.log('✅ Decrypted response:', decryptedData);

          const organizer = JSON.parse(localStorage.getItem('organizer') || 'null');
          const user = JSON.parse(localStorage.getItem('user') || 'null');

          // 🔥 pehle user.organizer se try karo
          const orgType = user?.organizer?.organizer_type || organizer?.organizer_type;
          const orgId = user?.organizer?.id || organizer?.id;

          if (!orgType || !orgId) {
            console.error('❌ Organizer data missing in both user & organizer');
            return;
          }
          // localStorage.setItem('organizer', JSON.stringify(decryptedData));
          this.router.navigate(['/gst-registration'], { queryParams: { id: orgId } });

        }
      },

      error: (err) => {
        console.log('Organizer response (error status)', err);

        // 🔥 IMPORTANT: backend encrypted data yahin aa raha hai
        if (err?.error?.data) {
          const decryptedData = this.enc.decrypt(err.error.data);
          console.log('✅ Decrypted response (409):', decryptedData.error);
          alert(decryptedData.error);

          localStorage.setItem('organizer', JSON.stringify(decryptedData));
        } else {
          console.error('❌ No encrypted data found');
        }
      }
    });
  }

  back() {
    //   const organizer = JSON.parse(localStorage.getItem('organizer') || 'null');
    //   const user = JSON.parse(localStorage.getItem('user') || 'null');
    //   if (user.organizer.organizer_type == "organization") {
    //     this.router.navigate(['/organize'], { queryParams: { id: user.organizer.id } });
    //   } else {
    //     this.router.navigate(['/individual'], { queryParams: { id: user.organizer.id } });
    //   }

    //   if (organizer.organizer_type == "organization") {
    //     this.router.navigate(['/organize'], { queryParams: { id: organizer.id } });
    //   } else {
    //     this.router.navigate(['/individual'], { queryParams: { id: organizer.id } });
    //   }
    // }
    const organizer = JSON.parse(localStorage.getItem('organizer') || 'null');
    const user = JSON.parse(localStorage.getItem('user') || 'null');

    // 🔥 pehle user.organizer se try karo
    const orgType = user?.organizer?.organizer_type || organizer?.organizer_type;
    const orgId = user?.organizer?.id || organizer?.id;

    if (!orgType || !orgId) {
      console.error('❌ Organizer data missing in both user & organizer');
      return;
    }

    if (orgType === 'organization') {
      this.router.navigate(['/organiser'], { queryParams: { id: orgId } });
    } else {
      this.router.navigate(['/individual'], { queryParams: { id: orgId } });
    }
  }

  next() {
    const id = this.organizerSession.getSessionOrganizerId();
    if (id == null) return;
    this.router.navigate(['/gst-registration'], { queryParams: { id } });
  }

}